export default {
  en: {
    supportTitle: 'Still have questions? Ask support',
    faqMenu: {
      clients: 'For clients',
      restaurants: 'For restaurants',
      partners: 'For partners',
      investors: 'For investors',
    },
  },
  ru: {
    supportTitle: 'Остались вопросы? Спросите поддержку',
    faqMenu: {
      clients: 'Клиентам',
      restaurants: 'Ресторанам',
      partners: 'Партнерам',
      investors: 'Инвесторам',
    },
  },
}
